import { useEffect, useState, type RefObject } from "react";

/**
 * Returns `true` once the element pointed to by `ref` has been at least
 * `threshold` visible inside the viewport. Latches `true` — the value
 * does not flip back to `false` if the element scrolls away. Used by
 * landing-page reveal animations.
 */
export function useIntersection(
  ref: RefObject<HTMLElement | null>,
  threshold = 0.15
) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setVisible(true);
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, threshold]);
  return visible;
}
